var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"appLayout"}},[_c('NavBar'),_c('div',{staticClass:"nj-views"},[_c('div',{staticClass:"nj-view-container"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }